// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2g8cD","inner":"Footer_inner__3MHhS","prices":"Footer_prices__cMQMI"};